<script>
import FTooltip from '../feedback/FTooltip.vue';
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: ['click', 'label', 'href', 'selected', 'variant'],
  methods: {
    click_callback : function()
    {
      if(this.href)
      {
        window.location.href = this.href;
      }
      else
      {
        this.$emit('click');
      }
    }
  },
};
</script>

<template>
    <button 
      class="keepfocus f-drop-down-button"
      :class="[variant, {selected}]"
      v-on:click="click_callback()">
      <slot></slot>
      <f-icon icon="fa6-angle-down" class="f-drop-down-button-icon" ></f-icon>
      
    </button>
</template>

<style lang="scss" scoped>


  .f-drop-down-button
  {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height:40px;
    padding-left:8px;
    padding-right:13px;
    border: none;
    font-size: 14px;
    font-weight:500;
    border-radius: 6px;
    font-family: Lato;
    gap:8px;
    background:none;
    color:rgba(255, 255, 255, 0.75);

    &:hover
    {
      color:var(--white);
      background: rgba(255, 255, 255, 0.1);
    }

    &.active,
    &:active
    {
      color:var(--white);
      background: rgba(24, 144, 211, 0.25);
    }

    &.active,
    &:active:hover
    {
      color:var(--white);
      background: rgba(255, 255, 255, 0.25);
    }

    &.selected
    {
        background: rgba(255, 255, 255, 0.1);
    }

  }

  .f-drop-down-button .f-drop-down-button-icon
  {
      font-size:14px;
  }

  .f-drop-down-button:disabled
  {
    opacity: 0.25;
  }

  .f-drop-down-button.default
  {
    color:var(--black-a75);
    outline: transparent;

    .f-drop-down-button-icon
    {
      color:var(--blue);
    }

    &:hover
    {
      background-color: var(--interactiveBlueHover);
      color:var(--black);
    }

    &:active,
    &:active:hover
    {
      background-color: var(--interactiveBluePress);
      color:var(--black);
    }

    &.active,
    &.active:active,
    &.active:active:hover
    {
      background-color: var(--interactiveBlueHover);
      color:var(--black);
      font-weight: 700;
    }
  }

  


</style>